import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton'
import StyleSheet from 'styles'
import AddIcon from '@material-ui/icons/Add'
import FormMixin from 'containers/shared/FormMixin'
import { CountryActions } from 'actionsets'
import { CountryGroupActions } from 'actionsets'
import { connect } from 'react-redux'

class OptionalFiltersList extends FormMixin(Component){
  constructor(props){
    super(props)
    let enabledAttributes = {}
    Object.entries(this.props.filters).forEach(([attribute, value]) => {
      if(value !== undefined)
        enabledAttributes[attribute] = true
    })
    this.state = {...this.state, enabled: enabledAttributes, open: false }
    CountryActions.bindActions(this, 'country')
    CountryGroupActions.bindActions(this, 'countryGroup')
  }

  provideCountriesAndCountryGroups = async(query) =>{
    const countriesTask = this.actions.country.search(query)
    const groupsTask = this.actions.countryGroup.search(query)

    const [countries, groups] = [await countriesTask, await groupsTask]

    const results = []
    if(groups.length){
      results.push({
        title: 'Groups',
        suggestions: groups,
        className: styles.countryGroupItem
      })
    }
    if(countries.length){
      results.push({
        title: 'Countries',
        suggestions: countries,
        className: styles.countryItem
      })
    }

    return results
  }

  handleCountryChange = ({target: {value}}) => {
    const {id, type, name} = (value || {})
    this.setAttribute('country', value ? {id, type, name} : value)
  }

  availableFilters = {
    country: {
      label: 'Country',
      attribute: 'country',
      scopes: ['investor_account', 'issuer_account'],
      type: 'AutoSuggest',
      onSuggestionsFetchRequested: this.provideCountriesAndCountryGroups,
      multiSection: true,
      onFilterChange: event => this.handleCountryChange(event)
    },
    dob: {
      label: 'DOB',
      attribute: 'dob',
      scopes: ['investor_account', 'issuer_account'],
      type: 'DateField'
    },
    account_name: {
      label: 'Account Name',
      attribute: 'account_name',
      scopes: ['investor_account', 'issuer_account'],
      type: 'TextField'
    }
  }

  enable = (attribute) =>{
    const enabled = {...this.state.enabled, [attribute]: true }
    this.setState({enabled})
  }

  disable = (attribute) =>{
    const enabled = {...this.state.enabled, [attribute]: false }
    this.setState({enabled})
  }

  handleFilterSelected = (attribute) => () => {
    this.enable(attribute)
    this.handleRequestClose()
  }

  handleFilterDestroy(attribute) {
    return () => {
      super.setAttribute(attribute, undefined)
      this.props.context.setAttribute(attribute, undefined)
      this.disable(attribute)
    }
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
  }

  setAttribute(attribute, value, callback){
    super.setAttribute(attribute, value, callback)
    this.props.context.setAttribute(attribute, value)
  }

  get formObject(){
    return this.props.filters
  }

  get activeFilters(){
    return Object.entries(this.state.enabled)
          .filter(([attribute, enabled]) => enabled)
          .map(([attribute]) => this.availableFilters[attribute])
          .filter(x => x)
  }

  renderFilter = ({type, scope, ...props}) =>{
    const {attribute, label} = props
    const FilterType = this[type]
    let filterComponent
    if (type === 'DateField') {
      filterComponent = [
        <FilterType key='start' label={`${label} After`} attribute={`${attribute}.start`}/>,
        <FilterType key='end' label={`${label} Before`} attribute={`${attribute}.end`}/>
      ]
    }
    else {
      filterComponent = <FilterType {...props}/>
    }
    return (
      <div key={attribute} className={styles.filterWrapper}>
        <div className={styles.filterComponent}>
          {filterComponent}
        </div>
        <div className={styles.filterAction}>
          <IconButton onClick={this.handleFilterDestroy(attribute)}>
            <DeleteIcon/>
          </IconButton>
        </div>
      </div>
    )
  }

  render = () => {
    return (
      <div>
        {this.activeFilters.map(this.renderFilter)}
        <div className={styles.filterButtons}>
          <Button variant='fab' color="primary" aria-label="add" onClick={this.handleClick}>
            <AddIcon />
          </Button>
        </div>
        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
        >
          {Object.entries(this.availableFilters)
                 .filter(([attribute]) => !this.state.enabled[attribute])
                 .map(([attribute, options]) =>
            <MenuItem onClick={this.handleFilterSelected(options.attribute)} key={options.attribute} value={options.attribute}>{options.label}</MenuItem>
          )}
        </Menu>
      </div>
    )
  }
}

const styles = StyleSheet({
  filterWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  filterComponent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  filterAction: {
    flex: 0,
    width: 50,
    display: 'flex',
    flexDirection: 'column',
    '& button': {
      flex: 1
    }
  },
  filterButtons: {
    display: 'flex',
    justifyContent: 'center'
  },
  countryItem: {
    height: 10
  },
  countryGroupItem: {
    height: 10,
    color: 'white',
    background: 'rgba(80, 80, 80, 0.5)'
  },
})

export default connect()(OptionalFiltersList)